<template>
	<el-main class="center-wrap feedback">
		<div class="card-header">
				<div>
					<div class="card-title">问题反馈</div>
					<div class="card-desc">提交问题或建议，帮助我们改进服务</div>
				</div>
			<!-- <el-button type="primary" size="small" @click="showFeedbackForm = true" icon="el-icon-plus">新建反馈</el-button> -->
		</div>

		<!-- 反馈列表 -->
		<div class="feedbackbox" v-loading="loading" element-loading-text="加载中...">
			<div v-if="list.length > 0">
				<el-card v-for="item in list" :key="item.id" class="feedback-item" :body-style="bodystyle" shadow="never">
					<div slot="header" class="feedback-header">
						<div class="feedback-title">
							<el-tag :type="getStatusType(item.status)" size="small">{{ getStatusText(item.status) }}</el-tag>
							<span class="feedback-type">{{ item.typeName }}</span>
						</div>
						<div class="feedback-date">{{ item.createTime }}</div>
					</div>
					<div class="feedback-content">
						<div class="feedback-info">
							<p><strong>问题描述：</strong>{{ item.feebackInfo }}</p>
							<p v-if="item.contactPerson"><strong>联系人：</strong>{{ item.contactPerson }}</p>
							<p v-if="item.contactPhone"><strong>联系电话：</strong>{{ item.contactPhone }}</p>
							<div v-if="item.feebackAnnex" class="feedback-attachments flexStart">
								<strong>附件：</strong>
								<el-link v-for="(file, index) in parseAttachments(item.feebackAnnex)" :key="index" type="primary" :underline="false" style="margin-right: 10px" @click="handlePreview(file)">
									{{ file.name }}
								</el-link>
							</div>
						</div>
						<div v-if="item.replyInfo" class="replyInfo flexStart">
							<p><strong>回复：</strong>{{ item.replyInfo }}</p>
						</div>
					</div>
				</el-card>

				<!-- 分页 -->
				<div class="pagination-container">
					<el-pagination @current-change="handlePageChange" :current-page="searchParams.pageNum" :page-size="searchParams.pageSize" :total="total" layout="total, prev, pager, next" background> </el-pagination>
				</div>
			</div>

			<!-- 空状态 -->
			<el-empty v-else description="暂无反馈记录">
				<!-- <el-button type="primary" @click="showFeedbackForm = true">立即反馈</el-button> -->
			</el-empty>
		</div>
	</el-main>
</template>

<script>
import Y from '@/utils/Y';
import mtils from 'mtils';
import { getMemberFeedbackList, getMemberFeedbackTypeList } from '@/api/user/feekback.js';
import FeedBackForm from '@/components/FeedBack/index.vue';
import FileInfo from '@/utils/GetFileUrl.js';

export default {
	data() {
		return {
			list: [],
			bodystyle: { padding: '0px' },
			loading: false,
			isCommentOpen: false,
			displayNum: 2,
			searchParams: {
				pageNum: 1,
				pageSize: 8
			},
			total: 0,
			typeList: []
		};
	},
	components: {
		FeedBackForm
	},

	created() {
		this.getMemberFeedbackTypeList();
	},
	methods: {
		//获取会员反馈类型列表
		async getMemberFeedbackTypeList() {
			const res = await getMemberFeedbackTypeList();
			this.typeList = res.data;
			this.getMemberFeedbackList();
		},

		//获取会员反馈列表
		async getMemberFeedbackList() {
			this.loading = true;
			const res = await getMemberFeedbackList(this.searchParams);
			this.list = res.data.rows;
			this.list.forEach(item => {
				item.typeName = this.typeList.find(type => type.id === item.feebackType)?.typeName || '未知';
				item.status = item.replyInfo ? 2 : 0;
			});
			this.total = res.data.totalNum;
			this.loading = false;
		},

		async handlePreview(file) {
			const url = await FileInfo.getFileUrl(file.url);
			window.open(url);
		},

		// 处理分页变化
		handlePageChange(page) {
			this.searchParams.pageNum = page;
			this.getMemberFeedbackList();
		},

		// 获取状态标签类型
		getStatusType(status) {
			const statusMap = {
				0: 'info', // 待处理
				1: 'warning', // 处理中
				2: 'success', // 已处理
				3: 'danger' // 已拒绝
			};
			return statusMap[status] || 'info';
		},

		// 获取状态文本
		getStatusText(status) {
			const statusMap = {
				0: '待处理',
				1: '处理中',
				2: '已处理',
				3: '已拒绝'
			};
			return statusMap[status] || '未知';
		},

		// 解析附件字符串为文件数组
		parseAttachments(attachmentStr) {
			if (!attachmentStr) return [];
			// 假设附件是以逗号分隔的URL字符串
			return attachmentStr.split(',').map((url, index) => ({
				name: `附件`,
				url: url.trim()
			}));
		}
	}
};
</script>

<style lang="less" scoped>
.center-wrap {
	padding: 20px;
}

.flexBetween {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;

	h3 {
		margin: 0;
		font-size: 20px;
		font-weight: 500;
		color: #334155;
	}
}

.feedbackbox {
	margin: 0;
}

.feedback-item {
	margin-bottom: 15px;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	transition: all 0.3s ease;

	&:hover {
		// box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		// border-color: #c0c4cc;
	}
}

.feedback-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px;
	border-bottom: 1px dashed #e2e8f0;
	background-color: #fafafa;
	border-radius: 8px 8px 0 0;

	.feedback-title {
		display: flex;
		align-items: center;
		gap: 10px;

		.feedback-type {
			font-size: 16px;
			font-weight: 500;
			color: #334155;
		}
	}

	.feedback-date {
		font-size: 14px;
		color: #94a3b8;
	}
}

.feedback-content {
	padding: 20px;

	.feedback-info {
		margin-bottom: 15px;

		p {
			margin: 8px 0;
			line-height: 1.6;
			color: #475569;

			strong {
				color: #334155;
				margin-right: 8px;
			}
		}
	}

	.feedback-attachments {
		strong {
			color: #334155;
		}
	}

	.replyInfo {
		padding-top: 15px;
		border-top: 1px solid #f0f2f5;

		strong {
			color: #334155;
		}

		p {
			margin: 4px 0;
			line-height: 1.6;
			color: #475569;
		}
	}
}

.pagination-container {
	display: flex;
	justify-content: flex-end;
	margin-top: 30px;
	padding: 20px 0;
}

// 空状态样式
/deep/ .el-empty {
	padding: 60px 0;

	.el-empty__description {
		margin-top: 20px;
		color: #94a3b8;
	}

	.el-button {
		margin-top: 20px;
	}
}

// 弹窗样式优化
/deep/ .el-dialog {
	border-radius: 12px;

	.el-dialog__header {
		padding: 20px;
		border-bottom: 1px dashed #e2e8f0;
		margin: 0;

		.el-dialog__title {
			font-size: 18px;
			font-weight: 500;
			color: #334155;
		}
	}

	.el-dialog__body {
		padding: 20px;
	}
}

// 响应式设计
@media screen and (max-width: 768px) {
	.flexBetween {
		flex-direction: column;
		align-items: flex-start;
		gap: 15px;

		.el-button {
			align-self: flex-end;
		}
	}

	.feedback-header {
		flex-direction: column;
		align-items: flex-start;
		gap: 10px;
	}

	.feedback-content {
		padding: 15px;
	}
}

// 原有样式兼容
.box-card {
	min-height: 190px;
	margin: 15px 9px;
}
.el-card {
	border: 1px solid #cccccc;
	color: #475569;
	font-size: 14px;
	line-height: 1.6;
}
/deep/ .el-card__header {
	padding: 0;
	color: #333333;
	font-size: 18px;
	border-bottom: none;
}
/deep/ .el-card__body {
	padding: 15px 20px;
}

//媒体查询-pad
@media screen and (min-device-width: 768px) and (max-device-width: 1023px) {
	.el-col-8 {
		width: 100%;
	}
}
@media screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
	.el-col-8 {
		width: 49.8%;
	}
}

	.card-header {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		margin-bottom: 24px;
		padding-bottom: 20px;
		border-bottom: 1px dashed #e2e8f0;
	}
	.card-title {
		font-size: 18px;
		font-weight: 700;
		color: #0f172a;
		margin-bottom: 4px;
	}
	.card-desc {
		font-size: 13px;
		color: #94a3b8;
		line-height: 1.6;
	}
</style>
